import type { CreateClientFormData } from '@/types/clientsApiTypes';

export function mapRelatedBasicInfoFormValues(client: CreateClientFormData): CreateClientFormData {
  const traveler = client.related_passengers[0];

  if (!traveler) {
    return client;
  }

  return {
    primary_passenger: {
      ...client.primary_passenger,
      client: { ...client.primary_passenger.client },
    },
    related_passengers: [
      {
        ...traveler,
        client: { ...traveler.client },
      },
      ...client.related_passengers.slice(1),
    ],
  };
}
